import { render, staticRenderFns } from "./wildbandito.vue?vue&type=template&id=8685d9f8&scoped=true"
import script from "./wildbandito.vue?vue&type=script&lang=js"
export * from "./wildbandito.vue?vue&type=script&lang=js"
import style0 from "./wildbandito.vue?vue&type=style&index=0&id=8685d9f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8685d9f8",
  null
  
)

export default component.exports